export default {
  'common.search': 'Rechercher',
  'common.explore': 'Explorer',
  'common.login': 'Connexion',
  'common.logout': 'Déconnexion',
  'common.register': 'Créer mon compte',
  'common.submit': 'Soumettre',
  'common.cancel': 'Annuler',
  'common.save': 'Enregistrer',
  'common.delete': 'Supprimer',
  'common.loading': 'Chargement...',
  'common.processing': 'Traitement...',
  'common.error': 'Erreur',
  'common.success': 'Succès',
  'common.warning': 'Avertissement',
  'common.info': 'Information',
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.previous': 'Précédent',
  'common.view': 'Voir',
  'common.edit': 'Modifier',
  'common.filters': 'Filtres',
  'common.reset': 'Réinitialiser',
  'common.apply': 'Appliquer',
  'common.confirmation': 'Confirmation',
  'common.confirm': 'Confirmer',
  'common.close': 'Fermer',
  'common.language': 'Langue',
  'common.currency': 'Devise',
  'common.settings': 'Paramètres',
  'common.profile': 'Profil',
  'common.dashboard': 'Tableau de bord',
  'common.account': 'Compte',
  'common.home': 'Accueil',
  'common.contact': 'Contact',
  'common.about': 'À propos',
  'common.help': 'Aide',
  'common.faq': 'FAQ',
  'common.login_required': 'Connexion requise',
  'common.login_to_continue': 'Veuillez vous connecter pour continuer',
  'common.login_to_favorite': 'Veuillez vous connecter pour ajouter aux favoris',
  'common.login_to_message': 'Veuillez vous connecter pour envoyer des messages',
  'common.login_to_book': 'Veuillez vous connecter pour réserver des rendez-vous',
  'common.email': 'Email',
  'common.password': 'Mot de passe',
  'common.remember_me': 'Se souvenir de moi',
  'common.forgot_password': 'Mot de passe oublié?',
  'common.no_account': 'Vous n\'avez pas de compte?',
  'common.have_account': 'Vous avez déjà un compte?',
  'common.agree_terms': 'J\'accepte les termes et conditions',
  'common.error_starting_conversation': 'Impossible de démarrer la conversation. Veuillez réessayer plus tard.',
  'common.login_signup': 'Connexion / Inscription',
  'common.and': 'et',
  'common.error_occurred': 'Une erreur est survenue',
  'common.verified': 'Vérifié(e)',
  'common.not_verified': 'Non vérifié(e)',
  'common.error_loading_data': 'Erreur lors du chargement des données',
  'common.unknown_error': 'Erreur inconnue',
  'common.choose_conversation': 'Choisissez une conversation pour commencer à discuter',

  'gender.female': 'Femme',
  'gender.male': 'Homme',
  'gender.trans': 'Transgenre',
  'gender.trans_female': 'Femme Trans',
  'gender.trans_male': 'Homme Trans',
  'gender.non_binary': 'Non Binaire',
  
  'navigation.explore': 'Explorer',
  'navbar.pricing': 'Nos offres',
  'navbar.register': 'S\'inscrire',
  'navbar.sugar_dating': 'Sugar Dating',
  'search.placeholder': 'Rechercher par nom, lieu, services...',
  'search.filters': 'Filtres',
  'search.results': '{{count}} profils',
  'search.showing_all': 'Affichage de tous les profils',
  'profileManagement.admin_tools': 'Outils d\'administration',
  'Verified': 'Vérifié',
  'Online': 'En ligne',
  'Touring': 'En tournée',
  'profile.favorite': 'Ajouter aux favoris',
  'View Profile': 'Voir le profil',
  'Message': 'Message',
  'profile.unfavorite': 'Retirer des favoris',
  
  'how_it_works.title': 'Comment ça marche',
  'how_it_works.subtitle': 'Découvrez comment notre plateforme vous connecte de manière sécurisée',
  'how_it_works.for_clients': 'Pour les clients',
  'how_it_works.browse_profiles': 'Parcourir les profils',
  'how_it_works.browse_profiles_desc': 'Explorez des milliers de profils vérifiés d\'escorts dans votre région',
  'how_it_works.subscribe': 'S\'abonner',
  'how_it_works.subscribe_desc': 'Choisissez un plan d\'abonnement pour débloquer des fonctionnalités premium',
  'how_it_works.connect': 'Se connecter',
  'how_it_works.connect_desc': 'Communiquez directement et en toute sécurité avec les escorts',
  'how_it_works.arrange': 'Organiser des rendez-vous',
  'how_it_works.arrange_desc': 'Planifiez facilement des rencontres selon vos disponibilités',
  'how_it_works.for_escorts': 'Pour les escorts',
  'how_it_works.create_profile': 'Créer un profil',
  'how_it_works.create_profile_desc': 'Créez un profil attrayant qui met en valeur vos services',
  'how_it_works.get_verified': 'Se faire vérifier',
  'how_it_works.get_verified_desc': 'Passez notre processus de vérification pour gagner la confiance des clients',
  'how_it_works.offer_subscriptions': 'Proposer des abonnements',
  'how_it_works.offer_subscriptions_desc': 'Gagnez des revenus supplémentaires grâce aux abonnements de contenu',
  'how_it_works.manage_bookings': 'Gérer les réservations',
  'how_it_works.manage_bookings_desc': 'Organisez votre emploi du temps et acceptez les rendez-vous qui vous conviennent',
  'how_it_works.secure_private': 'Sécurisé et privé',
  'how_it_works.secure_private_desc': 'Votre vie privée et votre sécurité sont notre priorité absolue',
  'how_it_works.verified_profiles': 'Profils vérifiés',
  'how_it_works.verified_profiles_desc': 'Tous les profils sont vérifiés pour assurer une expérience authentique',
  'how_it_works.secure_payments': 'Paiements sécurisés',
  'how_it_works.secure_payments_desc': 'Effectuez des transactions en toute confiance avec notre système de paiement sécurisé',
  'how_it_works.faq': 'Questions fréquentes',
  'how_it_works.faq_privacy': 'Comment protégez-vous ma vie privée?',
  'how_it_works.faq_privacy_answer': 'Nous utilisons un cryptage de pointe pour protéger vos données personnelles et ne partageons jamais vos informations avec des tiers',
  'how_it_works.faq_subscription': 'Comment fonctionnent les abonnements?',
  'how_it_works.faq_subscription_answer': 'Les abonnements vous donnent accès à du contenu exclusif et à des fonctionnalités premium. Vous pouvez vous abonner mensuellement ou annuellement',
  'how_it_works.faq_verification': 'Comment fonctionne la vérification?',
  'how_it_works.faq_verification_answer': 'Notre processus de vérification implique la confirmation de l\'identité via des documents officiels, garantissant que tous les profils sur notre plateforme sont authentiques',
  'how_it_works.ready': 'Prêt à commencer?',
  'how_it_works.join_today': 'Rejoignez-nous aujourd\'hui',
  'how_it_works.create_account': 'Créer un compte',
  'how_it_works.explore_profiles': 'Explorer les profils',
  
  // Pricing section
  'pricing.all_teaser': 'Tout ce qui est inclus dans Teaser',
  'pricing.all_regular': 'Tout ce qui est inclus dans Regular',
  'pricing.detailed_comparison': 'Comparaison détaillée',
  'pricing.feature': 'Fonctionnalité',
  'subscription.teaser.title': 'Teaser',
  'subscription.regular.title': 'Regular',
  'subscription.vip.title': 'VIP',
  'pricing.faq_title': 'Questions fréquentes sur les tarifs',
  'pricing.faq.how_subscriptions': 'Comment fonctionnent les abonnements?',
  'pricing.faq.how_subscriptions_answer': 'Nos abonnements vous donnent accès à du contenu premium et à des fonctionnalités exclusives. Choisissez entre des plans mensuels ou annuels.',
  'pricing.faq.payment_secure': 'Les paiements sont-ils sécurisés?',
  'pricing.faq.payment_secure_answer': 'Absolument. Nous utilisons un cryptage de niveau bancaire pour protéger vos informations de paiement.',
  'pricing.faq.refund': 'Puis-je obtenir un remboursement?',
  'pricing.faq.refund_answer': 'Nous offrons des remboursements dans certaines circonstances. Veuillez contacter notre support pour plus d\'informations.',
  'pricing.faq.verification': 'Comment fonctionne la vérification?',
  'pricing.faq.verification_answer': 'Notre processus de vérification garantit l\'authenticité de tous les profils sur notre plateforme.',
  
  // Blog section
  'blog.title': 'Blog',
  'blog.subtitle': 'Découvrez nos derniers articles et conseils',
  'blog.read_article': 'Lire l\'article',
  'blog.load_more': 'Charger plus',
  
  // FAQ section
  'faq.title': 'FAQ',
  'faq.subtitle': 'Réponses à vos questions fréquentes',
  'faq.search_placeholder': 'Rechercher dans les FAQ',
  'faq.search_button': 'Rechercher',
  'faq.still_questions': 'Vous avez encore des questions?',
  'faq.contact_support': 'Contactez notre support',
  'faq.contact_button': 'Contacter le support',
  
  // Legal sections
  'terms.title': 'Conditions d\'utilisation',
  'terms.subtitle': 'Veuillez lire attentivement nos conditions d\'utilisation',
  'terms.last_updated': 'Dernière mise à jour:',
  'terms.introduction.title': 'Introduction',
  'terms.introduction.content': 'Bienvenue sur notre plateforme. Les présentes conditions régissent votre utilisation de nos services.',
  
  'privacy.title': 'Politique de confidentialité',
  'privacy.subtitle': 'Comment nous protégeons vos données personnelles',
  'privacy.last_updated': 'Dernière mise à jour:',
  'privacy.introduction.title': 'Introduction',
  'privacy.introduction.content': 'Notre politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles.',
  
  'cookies.title': 'Politique des cookies',
  'cookies.subtitle': 'Comment nous utilisons les cookies sur notre site',
  'cookies.last_updated': 'Dernière mise à jour:',
  'cookies.introduction.title': 'Introduction',
  'cookies.introduction.content': 'Notre politique de cookies explique comment nous utilisons les cookies pour améliorer votre expérience sur notre site.',
  
  'content_policy.title': 'Politique de contenu',
  'content_policy.subtitle': 'Nos règles concernant le contenu publié sur la plateforme',
  'content_policy.last_updated': 'Dernière mise à jour:',
  'content_policy.introduction.title': 'Introduction',
  'content_policy.introduction.content': 'Notre politique de contenu définit les types de contenu autorisés et interdits sur notre plateforme.',
  
  // Ajout des clés manquantes liées au profil
  'profile.back': 'Retour',
  'profile.message': 'Message',
  'profile.booking': 'Réservation',
  'profile.tabs.about': 'À propos',
  'profile.tabs.services': 'Services',
  'profile.tabs.rates': 'Tarifs',
  'profile.premium_content': 'Contenu premium',
  'profile.rates': 'Tarifs',
  
  // Ajout des nouvelles clés manquantes
  'profile.about_me': 'À propos de moi',
  'profile.personal_information': 'Informations personnelles',
  'gender': 'Genre',
  'age': 'Âge',
  'profile.years': 'ans',
  'nationality': 'Nationalité',
  'ethnicity': 'Ethnicité',
  'eye_color': 'Couleur des yeux',
  'hair_color': 'Couleur des cheveux',
  'height': 'Taille',
  'unit_cm': 'cm',
  'weight': 'Poids',
  'unit_kg': 'kg',
  'measurements': 'Mensurations',
  'cup_size': 'Taille de bonnet',
  'intimate_area': 'Zone intime',
  'smoking': 'Tabac',
  'drinking': 'Alcool',
  'profile.sexual_details': 'Détails sexuels',
  'orientation': 'Orientation',
  'preferences': 'Préférences',
  'value_couples': 'Couples',
  'value_singles': 'Célibataires',
  'experience': 'Expérience',
  'value_intermediate': 'Intermédiaire',
  'kinks': 'Fantasmes',
  'value_roleplay_lightbdsm': 'Jeux de rôle et BDSM léger',
  'limits': 'Limites',
  'value_extreme_illegal': 'Pratiques extrêmes ou illégales',
  'profile.time': 'Durée',
  'profile.incall': 'Chez moi',
  'profile.outcall': 'Déplacement',
  'profile.available_services': 'Services disponibles',
  'profile.services_description': 'Services inclus dans les tarifs standards ou disponibles moyennant un supplément.',
  'profile.premium_services': 'Services premium',
  'profile.premium_services_description': 'Services numériques premium qui peuvent être achetés séparément sans réserver de rendez-vous.',
  'profile.service': 'Service',
  'profile.status': 'Statut',
  'profile.no_premium_services': 'Aucun service premium disponible',
  'profile.private_content_locked': 'Contenu privé verrouillé',
  'profile.private_content_subscription_needed': 'Abonnez-vous pour débloquer le contenu exclusif',
  'profile.subscribe_now': 'S\'abonner maintenant',
  'profile.private_media': 'Médias privés',
  'subscription.plans.basic.title': 'Basique',
  'subscription.plans.basic.price': '4,99€/mois',
  'subscription.plans.basic.benefits.messaging': 'Messagerie limitée',
  'subscription.plans.basic.benefits.photos': 'Photos de base',
  'subscription.plans.premium.title': 'Premium',
  'subscription.plans.premium.price': '19,99€/mois',
  'subscription.plans.premium.benefits.messaging': 'Messagerie illimitée',
  'subscription.plans.premium.benefits.photos': 'Photos exclusives',
  'subscription.plans.premium.benefits.verified': 'Badge vérifié',
  'subscription.plans.premium.benefits.priority': 'Support prioritaire',
  'subscription.plans.vip.title': 'VIP',
  'subscription.plans.vip.price': '100€/mois',
  'subscription.plans.vip.benefits.messaging': 'Messagerie prioritaire',
  'subscription.plans.vip.benefits.photos': 'Photos et vidéos exclusives',
  'subscription.plans.vip.benefits.verified': 'Badge VIP',
  'subscription.plans.vip.benefits.priority': 'Visibilité maximale',
  'subscription.plans.vip.benefits.exclusive': 'Avantages exclusifs',
  'subscription.plans.vip.benefits.support': 'Support dédié',
  'subscription.unlock_content': 'Débloquer le contenu',
  'subscription.choose_plan': 'Choisir un plan',
  'subscription.select_plan': 'Sélectionner',
  'subscription.recommended': 'Recommandé',
  
  // Ajout de la clé manquante récente
  'profile.private_access': 'Accès Privé',

  // From logs - CORRECTION: Removing incorrect prefixes and fixing key names
  'online': 'En ligne',
  'registered_date_prefix': 'Membre depuis',
  'profile.last_online': 'Dernière connexion',
  'today': 'aujourd\'hui',
  'total_views': 'Vues totales',

  // Admin Tabs from new logs
  'common.admin.tabs.users': 'Utilisateurs',
  'common.admin.tabs.reports': 'Signalements',
  'common.admin.tabs.verifications': 'Vérifications',
  'common.admin.tabs.supabase': 'Supabase',

  'common.or': 'ou',

  // Correction des clés précédemment ajoutées (suppression du préfixe common.) et ajout de la nouvelle clé
  'messages.search_placeholder': 'Rechercher une conversation...',
  'Select a conversation': 'Sélectionnez une conversation',
  'messages.book_appointment': 'Prendre un rendez-vous',
  'Select a date and time for your appointment.': 'Sélectionnez une date et une heure pour votre rendez-vous.',
  'Duration (minutes)': 'Durée (minutes)',
  'messages.time': 'Heure',
  'messages.no_messages_yet': 'Aucun message pour le moment.',
  'messages.no_conversations': 'Vous n\'avez aucune conversation pour le moment.',
  'common.actions': 'Actions',
  'common.retry': 'Réessayer',
  'search.no_profiles_found': 'Aucun profil trouvé',
  'search.no_profiles_message': 'Essayez d\'ajuster vos filtres ou revenez plus tard.',

  'ethnicity.asian': 'Asiatique',
  'ethnicity.black': 'Noir(e)',
  'ethnicity.caucasian': 'Caucasien(ne)',
  'ethnicity.hispanic_latino': 'Hispanique/Latino',
  'ethnicity.middle_eastern': 'Moyen-Oriental(e)',
  'ethnicity.native_american': 'Autochtone Américain(e)',
  'ethnicity.pacific_islander': 'Insulaire du Pacifique',
  'ethnicity.mixed': 'Métis(se)',
  'ethnicity.other': 'Autre',
  
  'body_type.slim': 'Mince',
  'body_type.athletic': 'Athlétique',
  'body_type.average': 'Moyen(ne)',
  'body_type.curvy': 'Pulpeux/se',
  'body_type.bbw': 'BBW/Costaud',
  'body_type.muscular': 'Musclé(e)',
  'body_type.petite': 'Petite',
  
  'orientation.heterosexual': 'Hétérosexuel(le)',
  'orientation.homosexual': 'Homosexuel(le)',
  'orientation.bisexual': 'Bisexuel(le)',
  'orientation.pansexual': 'Pansexuel(le)',
  'orientation.asexual': 'Asexuel(le)'
};
